import React from "react";
import { createContext } from "react";
import { BattleTeamType, useBattleTeamProvide } from "./useBattleTeamProvide";

export const battleTeamContext = createContext<BattleTeamType>({} as BattleTeamType);

const BattleTeamProvider: React.FC = ({ children }) => {
    const battleTeam = useBattleTeamProvide();
    return <battleTeamContext.Provider value={battleTeam}>{children}</battleTeamContext.Provider>;
};

export default BattleTeamProvider;
